export const BASE_URL = window.location.href.includes('debug=true') ? 'http://localhost:4000' : 'https://lawfeedback.onrender.com';
// export const BASE_URL = 'http://localhost:4000';
export const BASE_PAYPAL_REDIRECT_URL = window.location.origin;

export const HTTP = {
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE'
};

export const ENDPOINT = {
    registerWithSystem: 'auth/enroll?type=',
    DOCUMENTS: 'document',
    SIGN_DOC: 'document/sign',
    GOOGLE_ENROLL: 'auth/google_enroll?type=$',
    google_register: "auth/google_enroll",
    CHATS: 'chat',
    ALL_CHATS: 'chat/all',
    REFRESH_TOKEN: 'auth/refresh',
    LOGIN: 'auth/login',
    MESSAGES: 'chat/messages',
    DOCUMENTS_DOWNLOAD: 'document/download',
    TREE: 'tree',
    FOLDER: 'folder',
    CLIENTS: 'client',
    ALL_CLIENTS: 'client/all',
    CREATE_CLIENT: 'client/create',
    UPDATE_CLIENT: 'client/:client/update',
    DELETE_CLIENT: 'client/:client/delete',
    registerOrganization: 'org/register',
    getOrganization: 'org/all',
    getCase: "case/all?",
    createCase: 'case/create',
};

// En JavaScript, no es necesario usar tipos de TypeScript. Eliminamos la referencia a Endpoint.
export function isEndpoint(endpoint) {
   return ENDPOINT[endpoint] ?? new Error("Non existent endpoint");
}
